import { render, staticRenderFns } from "./DhmeAssemblyPreparationsModuleDetails.vue?vue&type=template&id=352dc75c&scoped=true"
import script from "./DhmeAssemblyPreparationsModuleDetails.vue?vue&type=script&lang=js"
export * from "./DhmeAssemblyPreparationsModuleDetails.vue?vue&type=script&lang=js"
import style0 from "./DhmeAssemblyPreparationsModuleDetails.vue?vue&type=style&index=0&id=352dc75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352dc75c",
  null
  
)

export default component.exports